import { render, staticRenderFns } from "./sbsp-salary-filter.vue?vue&type=template&id=5d32421c&scoped=true&"
import script from "./sbsp-salary-filter.vue?vue&type=script&lang=js&"
export * from "./sbsp-salary-filter.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-salary-filter.vue?vue&type=style&index=0&id=5d32421c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32421c",
  null
  
)

export default component.exports